import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { SalesListPage } from '../../../sales/sales-list/sales-list';
import { AnalyticsPage } from '../../../analytics/analytics';
import { HomeDashboardTkNoPaidPage } from './home-dashboard-tk-no-paid/home-dashboard-tk-no-paid';
/**
 * Generated class for the HomeDashboardBillingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-billing',
  templateUrl: 'home-dashboard-billing.html',
})
export class HomeDashboardBillingPage {

  total_pending: any = 0;
  total_tickets: any = 0;
  total_pending_takeaway: any = 0;
  total_takeaway: any = 0;
  data_sales_day: boolean = false;
  list_takeaways: any = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public translate: TranslateService) {
    this.salesDay();
    this.salesTkDay()
  }


  async salesDay() {
    //
    const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid);

    await this.http.post(this.globals.analytics_path + 'pending-tickets-in-invoices', body).subscribe(async data => {
      this.total_pending = data['total_amount'];
      this.total_tickets = data['total_tickets'];
      this.data_sales_day = true;
    },
      err => {
      }
    );
  }
  async salesTkDay() {
    //
    const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid);

    await this.http.post(this.globals.analytics_path + 'pending-takeaway-in-invoices', body).subscribe(async data => {
      this.total_pending_takeaway = data['total_amount'];
      this.total_takeaway = data['total_tables'];
      this.list_takeaways = data['list_takeaways'];
      this.data_sales_day = true;
    },
      err => {
      }
    );
  }

  openAnalytics() {
    if (this.globals.checkLimitsByLicense('sales', 'analytics')) {
      this.globals.side_menu_active = 'informes';
      this.navCtrl.push(AnalyticsPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openInvoices() {
    this.globals.side_menu_active = 'sales';
    this.navCtrl.push(SalesListPage);
  }

  openTkNoPaid() {
    this.navCtrl.push(HomeDashboardTkNoPaidPage, {
      list_takeaways: this.list_takeaways
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-billing/home-dashboard-billing.ts